import Image from 'next/image';
import Link from 'next/link';

export function BookmakerLogoImage({
  url,
  imageUrl,
  alt,
}: {
  url: string;
  alt: string;
  imageUrl: string;
}) {
  return (
    <div className="h-[30px] w-fit shrink-0 overflow-hidden">
      <Link href={url}>
        <Image
          alt={alt}
          className="h-full w-auto object-contain"
          height={0}
          sizes="160px"
          src={imageUrl}
          width={0}
        />
      </Link>
    </div>
  );
}
